import get from 'lodash/get';
import type { ApolloError } from 'apollo-client';

export type ErrorType = 'unknown' | 'network_error' | 'graphql_error';

export const getErrorType = (error: ApolloError | null): ErrorType => {
	if (!error) {
		return 'unknown';
	}

	return error.networkError ? 'network_error' : 'graphql_error';
};

export const getErrorStatus = (error: ApolloError | null): number | null => {
	if (!error) {
		return null;
	}

	if (error.networkError) {
		return null;
	}

	if (!error.graphQLErrors || !error.graphQLErrors.length) {
		return null;
	}

	return get(error.graphQLErrors[0], ['extensions', 'statusCode'], null);
};
